import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import NavigationBar from "@client.components/NavigationBar";
import TopBar from "@client.components/TopBar";
import { AuthorizedErrorMessage } from "@client.components/ErrorMessage";
import "./AuthorizedLayout.scss";

export const AuthorizedLayout = () => {
  const [topBarTitle, setTopBarTitle] = useState("");

  return (
    <div className="authorized-layout">
      <NavigationBar />
      <AuthorizedErrorMessage />
      <div className="main">
        <TopBar title={topBarTitle} />
        <Outlet context={[setTopBarTitle]} />
      </div>
    </div>
  );
};
